import { useCallback, useContext, useEffect, useMemo, useReducer, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useInput } from "./hooks/useInputs";
import { useTranslation } from "react-i18next";
import { generalDisabled } from "../../../../../../utils/validate/validate";
import { useCreatEdit } from "./hooks/useForm";
import { ServiceContext } from "../../context";
import { Action, State } from "./types";
import { ACTIONS } from "./enums/actions";
import { useFilter } from "../../../../../../hooks/filter";
import { formatFilter } from "./constans/constants"
import { catalog } from "../../../../../../utils/constants/callService";
import { Categories, Priority, User } from "../../../../../../service/catalog/response";
import { formatCatalogResponse } from "./methods/formatEndpointResponseToInformation";
import { Types } from "../../../../../../utils/enums"
import { Item } from "../../../../../../utils/types/generals";


const initialState: State = {
  openModal: { open: false },
  openModalConfirm: { open: false },
  openModalDelete: { open: false, confirm: undefined },
  editId: 0,
  searchSubServiceValue: undefined,
  loading: {
    createOrUpdate: false,
    table: false
  },
  snackbar: {
    message: '',
    open: false,
    type: Types.SUCCESS
  }
};


// Reducer para gestionar el estado
const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ACTIONS.OPEN_MODAL:
      return {
        ...state,
        openModal: {
          open: true,
          title: action.payload.title,
          cancel: action.payload.cancel,
        },
      };
    case ACTIONS.CLOSE_MODAL:
      return {
        ...state,
        openModal: null,
      };
    case ACTIONS.CHANGE_LOADER:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.type]: action.payload.value
        }
      };
    case ACTIONS.OPEN_MODAL_CONFIRM:
      return {
        ...state,
        openModalConfirm: {
          open: true,
          title: action.payload.title
        },
      };
    case ACTIONS.CLOSE_MODAL_CONFIRM:
      return {
        ...state,
        openModalConfirm: null,
      };
    case ACTIONS.SET_EDIT_ID:
      return {
        ...state,
        editId: action.payload,
      };
    case ACTIONS.OPEN_MODAL_DELETE:
      return {
        ...state,
        openModalDelete: {
          open: true,
          title: action.payload.title,
          description: action.payload.description,
          confirm: action.payload.confirm,
          cancel: action.payload.cancel,
        },
      };
    case ACTIONS.CLOSE_MODAL_DELETE:
      return {
        ...state,
        openModalDelete: null,
      };
    case ACTIONS.OPEN_SNACKBAR:
      return {
        ...state,
        snackbar: {
          ...state.snackbar,
          open: true,
          type: action.payload.type,
          message: action.payload.message
        },
      };
    case ACTIONS.CLOSE_SNACKBAR:
      return {
        ...state,
        snackbar: {
          ...state.snackbar,
          open:false
        },
      };
    case ACTIONS.RESET_EDIT_ID:
      return {
        ...state,
        editId: 0,
      };
    default:
      return state;
  }
};


const useBody = () => {
    const { id } = useParams()
    const [catalogName, setCatalogName] = useState('')
    const { t } = useTranslation()
    const navigate = useNavigate()
    const {data,onChange,handledata, dataCrud, handledataCrud, onChangeCrud} = useCreatEdit()
    const { input, inputFilter, inputCrud } = useInput()
    const {services, addService, addNewsService, removeService, removeNewsService, initializeServices, clearServices, clearNewsServices, editService, editOldService, newSubcategories, newsCategories, subcategoriesToDelete, categoriesToDelete, editCategories, editSubategories} = useContext(ServiceContext);

    const [state, dispatch] = useReducer(reducer, initialState);

    const newCatalog = () => {
      if(!id){
        return false
      }else{
        return !newsCategories.length && !newSubcategories.length && !categoriesToDelete.length && !subcategoriesToDelete.length && !editCategories.length && !editSubategories.length && dataCrud.catalogName == catalogName
      }
    }
    const paginationMain = useFilter({
      formatFilter
    })

    const normalizeString = (str:string) => str.trim().toLowerCase();

    const handleOpenModal = useCallback((id?:number,name?:string,priority?:Priority,provider?:User) => {
      if(id){
        dispatch({ type: ACTIONS.SET_EDIT_ID, payload: id });
        handledata({ nameCategory: name });
      }
      dispatch({
        type: ACTIONS.OPEN_MODAL,
        payload: {
          title: id ? t("catalog.messages.editCategory") : t("catalog.messages.addCategory"),
          cancel: () => {
            dispatch({ type: ACTIONS.CLOSE_MODAL });
            handledata();
            dispatch({ type: ACTIONS.RESET_EDIT_ID });
          },
        },
      });
    }, []);

    const handleConfirm = () => {
      if (state.editId !== 0) {
        editService(state.editId, String(data.nameCategory));
        editOldService(state.editId, String(data.nameCategory))
      } else {
        const newService: Categories = { id:  Math.floor(Math.random() * 10000) + 1, name: String(data.nameCategory), subcategories: [] };
        addService(newService);
        if(id){
          addNewsService(newService);
        }
      }
      dispatch({ type: ACTIONS.CLOSE_MODAL });
      handledata();
      dispatch({ type: ACTIONS.RESET_EDIT_ID });
      
    }

    const handleOpenModalDelete = useCallback((newId:number) => {
      dispatch({
        type: ACTIONS.OPEN_MODAL_DELETE,
        payload: {
          title: t("catalog.form.deleteTitle"),
          description: t("catalog.form.deleteDescription"),
          confirm: () => {
            removeService(newId);
            if(id){
              removeNewsService(newId);
            }
            dispatch({ type: ACTIONS.CLOSE_MODAL_DELETE });
          },
          cancel: () => {
            dispatch({ type: ACTIONS.CLOSE_MODAL_DELETE });
          },
        },
      });
    }, [newSubcategories, newsCategories, subcategoriesToDelete, categoriesToDelete]);
    
    const closeModalDelete = () => {
      dispatch({ type: ACTIONS.CLOSE_MODAL_DELETE });
    };

    const closeModalConfirm = () => {
      dispatch({ type: ACTIONS.CLOSE_MODAL_CONFIRM })
      navigate("../");
    }
 
    const disableCategoryForm = useMemo(() => generalDisabled(input, data), [data])
    const disableCrudForm = useMemo(() => generalDisabled(inputCrud, dataCrud), [dataCrud])

    const getCatalogById = async () => {
      dispatch({ type: ACTIONS.CHANGE_LOADER, payload:{type:'table',value:true} })
  
      const response = await catalog.getCatalogById(id ?? '')

      const { categories } = formatCatalogResponse({response})

      initializeServices(categories);
      handledataCrud({
        "catalogName": response.name ?? "",
        "statusId": response.statusId ?? 1,
      })
      setCatalogName(response.name ?? "")
      dispatch({ type: ACTIONS.CHANGE_LOADER, payload:{type:'table',value:false} })
    }

    const createOrUpdate = async () => {
      let body;
      dispatch({ type: ACTIONS.CHANGE_LOADER, payload:{type:'createOrUpdate',value:true} })
      if(id){

        body = {
          name: dataCrud.catalogName ?? "",
          statusId: dataCrud.statusId ?? 1,
          newsCategories: newsCategories.map(service => ({
            name: service.name,
            subcategories: service.subcategories.map(subcategory => ({
              name: subcategory.name,
              priorityId: subcategory.priority.id,
              requestText: subcategory.requestText,
              supplierId: subcategory.user ? subcategory.user.id : null,
            }))
          })),
          newSubcategories: newSubcategories.map(subService => ({
            categoryId: subService.parentId,
            name: subService.name,
            priorityId: subService.priority.id,
            requestText: subService.requestText,
            supplierId: subService.user ? subService.user.id : null
          })),
          categoriesToDelete: categoriesToDelete,
          subcategoriesToDelete: subcategoriesToDelete,
          editCategories: editCategories.map(editCategory => ({
            id: editCategory.id,
            name: editCategory.name
          })),
          editSubategories: editSubategories.map(editSubCategory => ({
            id: editSubCategory.id,
            name: editSubCategory.name,
            priorityId: editSubCategory.priority.id,
            requestText: editSubCategory.requestText,
            supplierId: editSubCategory.user?.id
          }))
        }
        const reponse = await catalog.updateCatalog(body,id)
        if(!reponse.errors){
          dispatch({ type: ACTIONS.OPEN_MODAL_CONFIRM, payload: {title:t(`catalog.modal.update.success.title`)} })
        }else{
          dispatch({ type: ACTIONS.OPEN_SNACKBAR, payload: { type: Types.ERROR, message: t(`catalog.modal.update.error.title`) } });
        }

      } else {

        body = {
          name: dataCrud.catalogName ?? "",
          categories: services.map(service => ({
            name: service.name,
            subcategories: service.subcategories.map(subcategory => ({
              name: subcategory.name,
              priorityId: subcategory.priority.id,
              requestText: subcategory.requestText,
              supplierId: subcategory.user ? subcategory.user.id : null,
            }))
          })),
        }
        const reponse = await catalog.createCatalog(body)
        if(!reponse.errors){
          dispatch({ type: ACTIONS.OPEN_MODAL_CONFIRM, payload: {title:t(`catalog.modal.create.success.title`)} })
        }else{
          dispatch({ type: ACTIONS.OPEN_SNACKBAR, payload: { type: Types.ERROR, message: t(`catalog.modal.create.error.title`) } });
        }

      }

      dispatch({ type: ACTIONS.CHANGE_LOADER, payload:{type:'createOrUpdate',value:false} })
    }

    const closeSnackbar = () => { 
      dispatch({ type: ACTIONS.CLOSE_SNACKBAR}); 
    }

    const [items, setItems] = useState< Item[] >()

    const getProviders = async () => {

      const response = await catalog.userList()

      const users = !response.errors
        ? response?.map((user) => {
          return {
            label: `${user.firstName} ${user.lastName}`,
            value: user.id,
          }
        }) as Item[]
        : []
  
      setItems(users)
    }

    useEffect(()=>{
      getProviders()
    },[id])


    useEffect(() => {
      clearNewsServices();
      if(id){
        getCatalogById();
      }else{
        clearServices()
      }
    }, [id]);

    return { 
        id,
        handleOpenModal,
        services,
        openModal: state.openModal,
        openModalConfirm: state.openModalConfirm,
        input,
        inputFilter,
        inputCrud,
        data,
        dataCrud,
        onChange,
        onChangeCrud,
        disableCategoryForm,
        disableCrudForm,
        handledata,
        openModalDelete: state.openModalDelete,
        handleOpenModalDelete,
        closeModalDelete,
        closeModalConfirm,
        handleConfirm,
        paginationMain,
        normalizeString,
        loading: state.loading,
        createOrUpdate,
        snackbar: state.snackbar,
        closeSnackbar,
        items,
        newCatalog
    }
}


export { useBody }